import { get, writable } from 'svelte/store';

const selectedProductStore = writable<string | undefined>(undefined);

export const getSelectedProduct = () => get(selectedProductStore);

export const selectProduct = (product: string) => selectedProductStore.set(product);

export const clearProductSelection = () => selectedProductStore.set(undefined);